import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { XCircleFill } from "react-bootstrap-icons";

const MultiSelect = forwardRef(
  (
    {
      options,
      placeholder,
      value,
      errors,
      name,
      className,
      size,
      disabled,
      onChange,
      formatOptionLabel,
      isClearable,
      onMenuOpen,
      menuScrollTo,
      isMulti,
      hideSelectedOptions,
      getOptionLabel,
      // ...rest
    },
    ref
  ) => {
    const handleClearAll = () => {
      onChange([]);
    };

    const customSmStyles = {
      control: (base) => ({
        ...base,
        minHeight: "29px",
        fontSize: "0.875rem",
        backgroundColor: "var(--falcon-input-bg)",
        borderColor: "var(--falcon-input-border-color)",
        "&:hover": {
          borderColor: "var(--falcon-input-focus-border-color)",
        },
      }),
      valueContainer: (base) => ({
        ...base,
        padding: "0 8px",
        color: "var(--falcon-input-color)",
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        color: "var(--falcon-input-color) !important",
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: "29px",
        minHeight: "29px",
        svg: {
          color: "var(--falcon-input-color) !important",
        },
      }),
      option: (base, { isFocused, isSelected }) => ({
        ...base,
        paddingTop: 8,
        paddingBottom: 0,
        paddingLeft: 10,
        paddingRight: 10,
        fontSize: "0.8rem",
        // backgroundColor: isSelected
        //   ? "var(--falcon-primary)"
        //   : "var(--falcon-card-bg)",
        // color: isSelected ? "var(--falcon-white)" : "var(--falcon-body-color)",
        minHeight: "30px",
        lineHeight: "1.2",
      }),
      menu: (base) => ({
        ...base,
        marginTop: 0,
        borderRadius: 0,
        backgroundColor: "var(--falcon-card-bg)",
        border: "1px solid var(--falcon-border-color)",
      }),
      menuList: (base) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
      }),
      multiValue: (base) => ({
        ...base,
        backgroundColor: "#fff",
        fontSize: "0.59rem",
        padding: "0 4px",
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: "var(--falcon-body-color)",
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: "var(--falcon-body-color)",
        "&:hover": {
          backgroundColor: "var(--falcon-danger)",
          color: "var(--falcon-white)",
        },
      }),
      placeholder: (base) => ({
        ...base,
        color: "var(--falcon-input-placeholder-color)",
        margin: 0,
        padding: 0,
      }),
    };

    const CustomMultiValueLabel = ({ data, selectProps }) => {
      if (value?.length < 2 && value?.length > 1) return;
      console.log({ data });
      const index = selectProps.value.indexOf(data);
      const total = selectProps.value.length;
      if (index === 0) {
        const label = getOptionLabel ? getOptionLabel(data) : data.label;
        return (
          <span>
            {label}
            {total > 1 && ` +${total - 1}`}
          </span>
        );
      }
      return; // Hide all other labels
    };

    const CustomMultiValueRemove = (props) => {
      const { data, selectProps } = props;
      const index = selectProps.value.findIndex((v) => v.value === data.value);

      // Only show "x" for the first item, and only if more than 1 selected
      if (index === 0 && selectProps.value.length > 1) {
        return <components.MultiValueRemove {...props} />;
      }
      return null; // hide cross for others
    };
    return (
      <div style={{ position: "relative" }}>
        <Select
          name={name}
          ref={ref}
          styles={customSmStyles}
          className={className}
          size={size}
          isMulti={isMulti}
          options={options}
          onMenuOpen={onMenuOpen}
          value={value}
          isDisabled={disabled}
          onChange={onChange}
          menuScrollTo={menuScrollTo}
          isClearable={isClearable}
          placeholder={placeholder}
          hideSelectedOptions={hideSelectedOptions}
          getOptionLabel={getOptionLabel}
          formatOptionLabel={formatOptionLabel}
          closeMenuOnSelect={!isMulti}
          classNamePrefix="react-select"
          errors={errors}
          components={{
            MultiValueLabel: CustomMultiValueLabel,
            MultiValueRemove: CustomMultiValueRemove,
          }}
        />
      </div>
    );
  }
);

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default MultiSelect;
